<template>
  <div>
    <p class="font-weight-bold mt-6 px-8">
      Påverkade tåg
    </p>

    <TrafficMessageRow :items="list" />
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import trainDeviationTypes from '@/common/trainDeviationTypes'
import TrafficMessageRow from './TrafficMessageRow'
import diffFactory from '@/helpers/diffFactory'

export default {
  name: 'TrafficMessageAffectedTrainsText',

  components: {
    TrafficMessageRow
  },

  computed: {
    trainDeviations: get('trainDeviation/data'),
    model: get('trafficMessage/model'),
    stops: get('event/stops'),

    list() {
      const findLocationName = signature => {
        const location = this.stops.find(
          x => x.short_name === signature.toUpperCase()
        )
        return location ? location.stop_name : signature.toUpperCase()
      }

      const getDeviationTypeText = x => {
        if (x.deviation_type === 'CANCELED_STOP') {
          return 'Bortfallet trafikutbyte'
        }

        return trainDeviationTypes[x.deviation_type]
      }

      const getPlaceText = x => {
        if (x.deviation_type === 'CANCELED_STOP') {
          return x.places
            ? x.places
                .split(', ')
                .map(findLocationName)
                .join(', ')
            : ''
        }

        return `${findLocationName(x.from)} - ${findLocationName(x.to)}`
      }

      const trainDeviations = diffFactory(
        this.model.train_deviations,
        x => `${getDeviationTypeText(x)}, ${x.train_number} ${getPlaceText(x)}`,
        this.trainDeviations
      )

      return trainDeviations
    }
  }
}
</script>
